import { i18n } from '@lingui/core';

export type StopeNoteApprovalPageParams = Readonly<Record<'accessToken' | 'projectId' | 'stopeNoteId', string | undefined>>;

export const ACCESS_TOKEN_IDENTIFIER = ':accessToken';
export const PROJECT_IDENTIFIER = ':projectId';
export const STOPE_NOTE_IDENTIFIER = ':stopeNoteId';

// https://localhost:5001/app/public/project/<mineModelId>/stopenote/<stopeNoteId>/token/<hash>
export const ROUTE_PATH = `/public/project/${PROJECT_IDENTIFIER}/stopenote/${STOPE_NOTE_IDENTIFIER}/token/${ACCESS_TOKEN_IDENTIFIER}`;
export const TITLE = i18n._('Approve Stope Note');
